// extracted by mini-css-extract-plugin
module.exports = {"SelectProductCategoryWrapper":"SelectProductCategory_SelectProductCategoryWrapper__wqL15"};